import {
    RiMessage2Line, RiPlayCircleLine, RiQuestionLine, RiSlackLine,
} from "@remixicon/react";
import React, {
    ReactElement,
} from "react";
import Button from "../../../../components/theme/button/Button";
import Link from "../../../../components/theme/button/Link";
import Icon from "../../../../components/theme/icon/Icon";
import { HelpTypes, useHelpContext } from "../../../../contexts/HelpContext";
import Styles from "./HomeV3.module.scss";

export default function Footer(): ReactElement {
    const helpContext = useHelpContext();

    return (

        <div className={Styles.footer}>
            <div className={Styles["footer-section"]}>
                <div className={Styles["footer-section-header"]}>
                    <Icon background="primary" isRounded variant="primary" size="xlarge" icon={<RiPlayCircleLine />} />
                    <strong>Watch a demo</strong>
                </div>
                <p>See how Foqal works with a quick, guided walkthrough of key features.</p>
                <Link
                    href="https://support.foqal.io/answers/urn%3Afq%3Aarticle%3A84d73b0beeac46ceb39ef7b1068d028d"
                    target="_blank"
                    variant="none"
                    rel="noreferrer"
                >
                    Watch Demo
                </Link>
            </div>
            <div className={Styles["footer-section"]}>
                <div className={Styles["footer-section-header"]}>
                    <Icon background="primary" isRounded variant="primary" size="xlarge" icon={<RiSlackLine />} />
                    <strong>Slack Support</strong>
                </div>
                <p>Connect directly with our support team in Slack for real-time assistance.</p>
                <Button
                    onClick={() => helpContext.show(HelpTypes.HELP)}
                    variant="none"
                >
                    Start a Slack Conversation
                </Button>
            </div>
            <div className={Styles["footer-section"]}>
                <div className={Styles["footer-section-header"]}>
                    <Icon background="primary" isRounded variant="primary" size="xlarge" icon={<RiQuestionLine />} />
                    <strong>Help Center</strong>
                </div>
                <p>Browse articles, tutorials, and FAQs to find answers to common questions.</p>
                <Link
                    href="https://support.foqal.io/answers"
                    target="_blank"
                    variant="none"
                    rel="noreferrer"
                >
                    Explore Help Center
                </Link>
            </div>
            <div className={Styles["footer-section"]}>
                <div className={Styles["footer-section-header"]}>
                    <Icon background="primary" isRounded variant="primary" size="xlarge" icon={<RiMessage2Line />} />
                    <strong>Leave Feedback</strong>
                </div>
                <p>Share your thoughts and suggestions to help us improve your experience.</p>
                <Button
                    onClick={() => helpContext.show(HelpTypes.FEEDBACK)}
                    variant="none"
                >
                    Leave Feedback
                </Button>
            </div>
        </div>

    );
}
